// Translations
import membersList from '../sections/members-list/translations/tr'

// Translation: Account > Members (Turkish)
export default Object.freeze({
	header: {
		subtitle: 'Takım üyelerini yönet ve yeni üyeler ekle',
		title: 'Takım üyeleri'
	},
	sections: { membersList }
})
